/**
=========================================================
* Vue Argon Dashboard 2 PRO - v3.0.1
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router/router";
import VueTilt from "vue-tilt.js";
//import ArgonDashboard from "./argon-dashboard";

//Style
import "./assets/css/theme.css";
import 'vuetify/dist/vuetify.min.css';
import 'vuetify/styles';
import "./assets/css/nucleo-icons.css";

import "./assets/css/nucleo-svg.css";
import 'primeicons/primeicons.css'
import "./assets/css/custom.css";
// import "./assets/css/css_theme.min.css";

//fontawesome
import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
config.autoAddCss = false
library.add(fas)
library.add(far)

// Vuetify
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components'; // Import Vuetify components
import * as directives from 'vuetify/directives'; // Import Vuetify directives

//ECharts
import ECharts from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { GraphicComponent, PolarComponent } from 'echarts/components';
import { LineChart, PieChart, BarChart, TreeChart, TreemapChart, SankeyChart, RadarChart, FunnelChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, TitleComponent, LegendComponent, ToolboxComponent, DataZoomComponent } from 'echarts/components';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
use([CanvasRenderer, LineChart, GridComponent, TooltipComponent, TitleComponent, LegendComponent, ToolboxComponent, DataZoomComponent, PieChart, BarChart, TreeChart, SankeyChart, GraphicComponent, CanvasRenderer, TreemapChart, RadarChart, FunnelChart, PolarComponent]);

//Labels
import { createI18n } from 'vue-i18n';
import it from './locales/it.json';
const i18n = createI18n({
    locale: 'it', // Set the default language
    fallbackLocale: 'it', // Fallback language if translation is missing
    missing: (locale, key) => {
        return key;
    },
    messages: {
        it  // Italian translations
    }
});


//Log
import { log } from "@/script/log"


import { createStore } from "vuex";

import ConfirmationService from 'primevue/confirmationservice';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';

const italian = require("../node_modules/primelocale/it.json");
const appInstance = createApp(App);
appInstance.use(i18n);
appInstance.use(store);
appInstance.use(ConfirmationService);
appInstance.use(PrimeVue, {
    theme: {
        preset: Aura
    },
    locale: { ...italian.it }
});
appInstance.use(router);
appInstance.use(VueTilt);
appInstance.use(createVuetify({
    components,
    directives,
    theme: {
        isDisabled: true
    }
})); // Register Vuetify
appInstance.component('v-chart', ECharts);
appInstance.component('font-awesome-icon', FontAwesomeIcon);

appInstance.config.globalProperties.$logDbg = function (filename, message, value, value2, value3, value4) {
    log("DBG", filename, message, value, value2, value3, value4, process.env.VUE_APP_DEBUG_MODE);
};
appInstance.config.globalProperties.$logWarn = function (filename, message, value, value2, value3, value4) {
    log("WARN", filename, message, value, value2, value3, value4, process.env.VUE_APP_DEBUG_MODE);
};
appInstance.config.globalProperties.$logErr = function (filename, message, value, value2, value3, value4) {
    log("ERR", filename, message, value, value2, value3, value4, process.env.VUE_APP_DEBUG_MODE);
};

appInstance.config.errorHandler = function (err, instance, info) {
    console.log(`Error: ${err.toString()}\nInfo: ${info}`, err);
    if (instance && instance.$store) {
        instance.$store.commit('addMessage', {
            message: "Error " + err.toString(),
            messageType: 'error'
        });
    }
}




//appInstance.use(ArgonDashboard);
appInstance.mount("#app");
